var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.25C1 17.2827 3.93367 14.0006 7.75 13.4548M18.8567 14.7293C18.78 14.7339 18.7027 14.7363 18.625 14.7363C17.4725 14.7363 16.4212 14.2214 15.625 13.375C14.8288 14.2214 13.7775 14.7361 12.625 14.7361C12.5473 14.7361 12.4701 14.7338 12.3933 14.7292C12.2997 15.1585 12.25 15.6087 12.25 16.0726C12.25 18.5636 13.6841 20.6566 15.625 21.25C17.5659 20.6566 19 18.5636 19 16.0726C19 15.6087 18.9503 15.1585 18.8567 14.7293ZM13.375 5.5C13.375 7.98528 11.3602 10 8.875 10C6.38972 10 4.375 7.98528 4.375 5.5C4.375 3.01472 6.38972 1 8.875 1C11.3602 1 13.375 3.01472 13.375 5.5Z",
    stroke: "#8D8080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/adult.8a1133c7fd10ef475f3fa3c7b6f0cafa.svg";
export { ForwardRef as ReactComponent };